import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { CalendarEvent, CalendarMonthViewComponent } from 'angular-calendar';
import { isSameDay } from 'date-fns';
import { MonthViewDay, WeekDay } from 'calendar-utils';

@Component({
    selector: 'sgt-calendar-month-view-mini',
    templateUrl: 'calendar-month-view-mini.component.html',
    styleUrls: ['./calendar-month-view-mini.component.less']
})
export class CalendarMonthViewMiniComponent implements OnChanges {
    @Input() locale = 'pt-BR';
    @Input() viewDate: Date;
    @Output() viewDateChange = new EventEmitter<Date>();
    @Input() startDate: Date = new Date();
    @Output() startDateChange = new EventEmitter<Date>();
    @Input() endDate: Date = new Date();
    @Output() endDateChange = new EventEmitter<Date>();
    @Output() datesChange = new EventEmitter<void>();

    @Input() events: CalendarEvent[];
    @Input() eventTemplate: TemplateRef<any>;

    @Output() eventClicked = new EventEmitter<CalendarEvent>();

    @ViewChild('monthView', {static: true}) monthView: CalendarMonthViewComponent;
    activeDay: MonthViewDay;
    eventsList: CalendarEvent[] = [];

    trackByEventId = (index: number, event: CalendarEvent) => event.id ? event.id : event;
    trackByWeekDayHeaderDate = (index: number, day: WeekDay) => day.date.toISOString();

    constructor(private ref: ChangeDetectorRef) { }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'viewDate') {
                this.changeActiveDay();
            } else if (propName === 'events') {
                if (!changes[propName].isFirstChange()) {
                    this.changeActiveDay();
                }
            }
        }
    }

    /** Ao clicar em algum dia do calendar */
    dayClicked({day}: {day: MonthViewDay}): void {
        this.activeDay = day;
        this.viewDate = day.date;
        this.viewDateChange.emit(this.viewDate);
    }

    /** Altera o dia ativo do calendar e seta os eventos do dia no list view */
    private changeActiveDay() {
        setTimeout(() => {
            this.activeDay = this.monthView.view.days.find(day => isSameDay(day.date, this.viewDate));
            this.eventsList = this.activeDay?.events ?? [];
            this.ref.detectChanges();
        }, 0);
    }
}
